import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { camelCase } from 'lodash';

@Pipe({
    name: 'translateColumn',
    pure: false,
    standalone: false
})
export class TranslateColumnPipe implements PipeTransform {

  constructor(private readonly translateService: TranslateService) {
  }

  transform(value: string, boardName: string): string {
    return this.translateService.instant(`dashboard.${camelCase(boardName)}.columns.${value}`)
  }

}
